import { render } from "./oncology_head.vue?vue&type=template&id=726c92d7&scoped=true"
import script from "./oncology_head.vue?vue&type=script&lang=js"
export * from "./oncology_head.vue?vue&type=script&lang=js"

import "./oncology_head.vue?vue&type=style&index=0&id=726c92d7&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726c92d7"]])

export default __exports__